import React, { createContext } from 'react';

export const TwoColumnContext = createContext<boolean>(false);
